import React, { useEffect, useState } from 'react';
import axios from 'axios'
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import Select, { components } from 'react-select';
import 'react-tabs/style/react-tabs.css';
import { toast } from 'react-toastify';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/id';

import Switch from "react-switch";
import { isEmpty } from "../../helper/helper.js"

function CourierForm({ props = {} }) {


  const [appData, setAppData] = useState({ active: true, endpoint: {}, configs: {} })
  const [formData, setFormData] = useState({
    mProvince: [],
    mCity: [],
    mDistrict: [],
    mSubDistrict: []
  });

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target
    setAppData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const handleOnChangeSwitch = async (c, e, id) => {
    setAppData(prevState => ({ ...prevState, [id]: c }))
  }

  const onChangeJsonFormat = async (e) => {
    const validJson = (e.jsObject === undefined) ? false : true;
 
    if (validJson) {
      setAppData(prevState => ({
        ...prevState,
        [e.id]: e.jsObject ?? {}
      }))
    } else {
      toast.error('Invalid JSON Format')
    }

  }


  // Custom Option component for the dropdown menu
  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div>{props.data.label} - <span className='fw-bold fs-6'>{props.data.postalcode}</span></div>
      </components.Option>
    );
  };

  const onChangeProvince = async (option, e) => {
    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        province: option.value,
        provinceName: option.label,
        city: '',
        cityName: '',
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      await axios.get(`${window.API_HOST}/ui/v1/form/city`, {
        params: { prov_code: option.value }
      }).then(async (res) => {
        const resp = res.data
        const cities = resp.data.city;
        setFormData(prevState => ({ ...prevState, mCity: cities }))
      }).catch(err => {
      })
    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        province: '',
        provinceName: '',
        city: '',
        cityName: '',
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      setFormData(prevState => ({
        ...prevState,
        mCity: [],
        mDistrict: [],
        mSubDistrict: []
      }))
    }
  }

  const onChangeCity = async (option, e) => {
    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        city: option.value,
        cityName: option.label,
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      await axios.get(`${window.API_HOST}/ui/v1/form/district`, {
        params: {city_code: option.value}
      }).then(async (res) => {
        const resp = res.data 
        const districts = resp.data.district;
        setFormData(prevState => ({ ...prevState, mDistrict: districts }))
      }).catch(err => {
      })

    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        city: '',
        cityName: '',
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      setFormData(prevState => ({
        ...prevState,
        mDistrict: [],
        mSubDistrict: []
      }))
    }

  }

  const onChangeDistrict = async (option, e) => {
    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        district: option.value,
        districtName: option.label,
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      await axios.get(`${window.API_HOST}/ui/v1/form/subdistrict`, {
        district_code: option.value
      }).then(async (res) => {
        const subdistricts = res.data.subdistrict ?? [];
        console.log(subdistricts)
        setFormData(prevState => ({ ...prevState, mSubDistrict: subdistricts }))
      }).catch(err => {
      })

    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      setFormData(prevState => ({
        ...prevState,
        mDistrict: [],
        mSubDistrict: []
      }))
    }

  }

  const onChangeSubDistrictPostalCode = async (option, e) => {

    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        subDistrict: option.value,
        subDistrictName: option.label,
        postalCode: option.postalcode
      }))

    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        subDistrict: '',
        subDistrictName: '',
        postalCode: '',
      }))

    }
  }

  const saveAction = async (e) => {
    e.preventDefault()

    let payload = {
      code: appData.code,
      name: appData.name,
      alias: appData.alias,
      endpoint: appData.endpoint,
      configs: appData.configs,
      address: appData.address,
      province: appData.province,
      provinceName: appData.provinceName,
      city: appData.city,
      cityName: appData.cityName, 
      district: appData.district,
      districtName: appData.districtName,
      subdistrict: appData.subDistrict,
      subdistrictName: appData.subDistrictName,
      postalcode: appData.postalCode,
      phone: appData.phone,
      email: appData.email,
      active: appData.active,
    }

    /**
     * check / validate data 
     */

    if (isEmpty(appData.code) || isEmpty(appData.name)) {
      toast.error('Code / Name is required')
      return 
    }

    if (!props.uid) {
      // New 
      await axios.post(`${window.API_HOST}/v1/courier`, payload).then(async (res) => {
        const resp = res.data
        setAppData(prevState => ({
          ...prevState,
          uid: resp.data.uid,
          updated_at: resp.data.updated_at,
          updated_by: resp.data.updated_by
        }))
        props.uid = resp.data.uid
        toast.success(`Success save courier ${appData.name}`)
      }).catch(err => {
        toast.error(err.response.data.error)
      })
    } else {

      //Update
      await axios.put(`${window.API_HOST}/v1/courier/${props.uid}`, payload).then(async (res) => {
        const resp = res.data

        setAppData(prevState => ({
          ...prevState,
          updated_at: resp.data.updated_at,
          updated_by: resp.data.updated_by
        }))
        toast.success(`Success update courier ${appData.name}`)
      }).catch(err => {
        toast.error(err.response.data.error)
      })

    }


  }

  const retrieveData = async () => {

    await axios.get(`${window.API_HOST}/v1/courier/${props.uid}`).then(async (res) => {
      const resp = res.data
      
      setAppData(prevState => ({
        ...prevState,
        code: resp?.data?.code,
        name: resp?.data?.name,
        address: resp?.data?.address,
        province: resp?.data.province,
        provinceName: resp?.data.province_name,
        city: resp?.data.city,
        cityName: resp?.data.cityName,
        active: resp?.data?.active ?? false,
        endpoint: resp?.data?.endpoint ?? {},
        configs: resp?.data?.configs ?? {}, 
        updated_at: resp?.data?.updated_at,
        updated_by: resp?.data?.updated_by
      }))

    }).catch(err => {
      toast.error(err.response.data.error)
    })

  }

  async function fetchForm() {
    await axios.get(`${window.API_HOST}/ui/v1/form/province`)
      .then(res => {
        const resp = res.data;
        setFormData(prevState => ({
          ...prevState,
          mProvince: resp?.data?.province ?? []
        }))

      }).catch(err => { 
      })
  }

  useEffect(() => {

    //load ui data form
    fetchForm()

    if (props?.uid) {
      retrieveData()
    }

  }, []);

  return (
    <div>
      <div className='m-0 p-0' >
        <Panel >
          <PanelHeader className="bg-purple-200  p-2 p-r-0" noButton>
            <div className='row'>
              <div className='col-sm-6 fw-bolder fs-2 text-black'>{props.uid ? 'Update' : 'Create'} Courier</div>
              <div className='col-sm-6 align-items-baseline text-end'>
                <div className=''>
                  {(true) ? <button className="btn btn-sm btn-primary ms-3 f-s-11 text-center ml-3" onClick={saveAction}><i className="fa fa-save"></i> Save</button> : null}
                  {(true) ? <button className="btn btn-sm btn-danger ms-3 f-s-11 text-center ml-3" onClick={props.cancelAction}><i className="fa fa-minus-circle"></i> Close</button> : null}
                </div>

              </div>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="row" >
              <div className='col-sm-12'>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Code</label>
                  <div className="col-sm-8">
                    <input type="text" name="code" value={appData.code ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" disabled={props.uid} />
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Name</label>
                  <div className="col-sm-8">
                    <input type="text" name="name" value={appData.name ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Alias</label>
                  <div className="col-sm-8">
                    <input type="text" name="alias" value={appData.alias ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                  </div>
                </div>
                <div className="form-group row mb-10">
                  <label className="col-sm-3 col-form-label">Active</label>
                  <div className="col-sm-8">
                    <Switch id="active" name="active" onChange={handleOnChangeSwitch} checked={appData.active ?? false} />
                  </div>
                </div>
                 <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Updated By</label>
                  <div className="col-sm-8">
                    <div className='row'>
                      <div className='col-sm-6'>
                        <input type="text" value={appData.updated_by ?? ""}  className="form-control form-control-sm" disabled={true} />
                      </div>
                      <div className='col-sm-6'>
                        <input type="text" value={appData.updated_at ?? ""}  className="form-control form-control-sm" disabled={true} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <Tabs className="m-0 p-0 h-600px" style={{ 'width': '950px', }}>
                <TabList>
                  <Tab><i className="fa fa-address-card"></i> Address</Tab> 
                  <Tab><span className="fa fa-link"></span> End Point</Tab>
                  <Tab><i className="fa fa-cog"></i> Configs</Tab>
                </TabList>

                <TabPanel>
                  <div className="row">
                    <div className='col-sm-12 bg-grey-transparent-1 pt-2'>
                      <div className="form-group row mb-1">
                        <div className="col-sm-12">
                          <textarea name="address"
                            onChange={handleOnChangeInputText} value={appData.address ?? ""}
                            className='form-control form-control-sm' placeholder="Address" ></textarea>
                        </div>
                      </div>
                      <div className="form-group row mb-1">
                        <div className="col-sm-6">
                          <Select name="province" placeholder={"Province"}
                            value={formData.mProvince.find(({ value }) => { return value === appData.province }) ?? ""}
                            options={formData.mProvince}
                            onChange={onChangeProvince}
                            isClearable={true} isSearchable={true} />
                        </div>
                        <div className="col-sm-6">
                          <Select name="city" placeholder={"City"}
                            value={formData.mCity.find(({ value }) => { return value === appData.city }) ?? ""}
                            options={formData.mCity}
                            onChange={onChangeCity}
                            isClearable={true} isSearchable={true} />
                        </div>
                      </div>
                      <div className="form-group row mb-1">
                        <div className="col-sm-6">
                          <Select name="district" placeholder={"District"}
                            value={formData.mDistrict.find(({ value }) => { return value === appData.district; }) ?? ""}
                            options={formData.mDistrict}
                            onChange={onChangeDistrict}

                            isClearable={true} isSearchable={true} />
                        </div>
                        <div className="col-sm-6">
                          <Select name="subDistrict" placeholder={"Sub District"}
                            value={formData.mSubDistrict.find(({ value }) => { return value === appData.subDistrict }) ?? ""}
                            options={formData.mSubDistrict}
                            onChange={onChangeSubDistrictPostalCode}
                            components={{ Option: CustomOption }}
                            isClearable={true} isSearchable={true} />
                        </div>
                      </div>
                      <div className="form-group row mb-1">
                        <div className="col-sm-6">
                          <input type="text" name="postalCode" value={appData.postalCode ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" placeholder='Postal Code' />
                        </div>
                        <div className="col-sm-6">
                          <input type="text" value={appData.originHub} onChange={() => { }} className="form-control form-control-sm bg-grey-transparent-1" readOnly={true} disabled />
                        </div>
                      </div>
                      <div className="form-group row mb-1">
                        <div className="col-sm-6">
                          <input type="text" name="phone" value={appData.phone ?? ""}
                            onChange={handleOnChangeInputText}
                            className="form-control form-control-sm" placeholder="Phone" />
                        </div>
                        <div className="col-sm-6">
                          <input type="text" name="email" value={appData.email ?? ""}
                            onChange={handleOnChangeInputText}
                            className="form-control form-control-sm" placeholder="Email" />
                        </div>
                      </div>
                    </div>

                  </div>
                </TabPanel> 
                <TabPanel>
                  <div className="row m-0 p-0" >
                    <div className="col-sm-12 m-0 p-0">
                      <div className="row row overflow-scroll m-0 p-0">
                        <div className="col-sm-12">
                          <JSONInput
                            id='endpoint'
                            name="endpoint"
                            placeholder={appData.endpoint ?? {}}
                            value={appData.endpoint ?? {}}
                            onChange={(e) => { e.id = 'endpoint';  onChangeJsonFormat(e)}}
                            colors={{
                              background: "rgba(182,194,201,.1)",
                              default: "black",
                              keys: "red"
                            }}
                            theme={"light_mitsuketa_tribute"}
                            locale={locale}
                            // onKeyPressUpdate={true}
                            waitAfterKeyPress={2500}
                            width={'auto'}
                            height='300px'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="row m-0 p-0" >
                    <div className="col-sm-12 m-0 p-0">
                      <div className="row row overflow-scroll m-0 p-0">
                        <div className="col-sm-12">
                          <JSONInput
                            id='configs'
                            name="configs"
                            placeholder={appData.configs ?? {}}
                            value={appData.configs ?? {}}
                            onChange={(e) => { e.id = 'configs';  onChangeJsonFormat(e)}}
                            colors={{
                              background: "rgba(182,194,201,.1)",
                              default: "black",
                              keys: "red"
                            }}
                            theme={"light_mitsuketa_tribute"}
                            locale={locale}
                            // onKeyPressUpdate={true}
                            waitAfterKeyPress={1000}
                            width={'auto'}
                            height='300px'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </PanelBody>
        </Panel>
      </div>
    </div>

  )


}

export default CourierForm